import { SET_CUSTOMERS_CHANGE_DATA, SET_CUSTOMERS_DIFF_OBJECT, SET_CUSTOMERS_CHANGE_DATA_VALUES, UPDATE_CUSTOMERS_CHANGE_DATA_VALUES, RESET_CUSTOMERS_CHANGE_DATA, RESET_CUSTOMERS_CHANGES, SET_SELECTED_CUSTOMERS_LOCATIONS, UPDATE_CUSTOMERS_ERRORS, CLEAR_CUSTOMERS_ERROR, SET_CUSTOMERS_ERRORS } from './chunk-J5L5LOZ4.mjs';
import { __export } from './chunk-T36PI2YV.mjs';

// src/state/customers/changeData/actions.ts
var actions_exports = {};
__export(actions_exports, {
  clearCustomersError: () => clearCustomersError,
  resetCustomersChangeData: () => resetCustomersChangeData,
  resetCustomersChanges: () => resetCustomersChanges,
  setCustomersChangeData: () => setCustomersChangeData,
  setCustomersChangeDataValues: () => setCustomersChangeDataValues,
  setCustomersDiffObject: () => setCustomersDiffObject,
  setCustomersErrors: () => setCustomersErrors,
  setSelectedCustomersLocations: () => setSelectedCustomersLocations,
  updateCustomersChangeDataValues: () => updateCustomersChangeDataValues,
  updateCustomersErrors: () => updateCustomersErrors
});
var setCustomersChangeData = (payload) => ({
  type: SET_CUSTOMERS_CHANGE_DATA,
  payload
});
var setCustomersDiffObject = (payload) => ({
  type: SET_CUSTOMERS_DIFF_OBJECT,
  payload
});
var setCustomersChangeDataValues = (data, sectionId = "all") => ({
  type: SET_CUSTOMERS_CHANGE_DATA_VALUES,
  payload: { data, sectionId }
});
var updateCustomersChangeDataValues = (payload) => ({
  type: UPDATE_CUSTOMERS_CHANGE_DATA_VALUES,
  payload
});
var resetCustomersChangeData = () => ({
  type: RESET_CUSTOMERS_CHANGE_DATA
});
var resetCustomersChanges = (payload) => ({
  type: RESET_CUSTOMERS_CHANGES,
  payload
});
var setSelectedCustomersLocations = (payload) => ({
  type: SET_SELECTED_CUSTOMERS_LOCATIONS,
  payload
});
var updateCustomersErrors = (payload) => ({
  type: UPDATE_CUSTOMERS_ERRORS,
  payload
});
var clearCustomersError = (payload) => ({
  type: CLEAR_CUSTOMERS_ERROR,
  payload
});
var setCustomersErrors = (payload) => ({
  type: SET_CUSTOMERS_ERRORS,
  payload
});

export { actions_exports, clearCustomersError, resetCustomersChangeData, resetCustomersChanges, setCustomersChangeData, setCustomersChangeDataValues, setCustomersDiffObject, setCustomersErrors, setSelectedCustomersLocations, updateCustomersChangeDataValues, updateCustomersErrors };
